<template>
	<div :class="classNames">
		<el-steps simple :active="1" finish-status="success" style="margin-bottom: 24px" v-if="$route.params.type == 'column'">
			<el-step title="第一步:课程详情内容"></el-step>
			<el-step title="第二步:批量创建课程" class="el-steps-color"></el-step>
		</el-steps>
		<div :class="classNames+ '_search'">
			<el-button type="primary" @click.prevent.stop="addGroup">新建分组</el-button>
			<el-button style="transform: translateX(-94px);" type="primary" @click="()=> {createClass()}">新建章节</el-button>
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">状态</span>
					<el-select v-model="searchObj.status" placeholder="请选择" @change="changeStatus">
						<el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<el-input placeholder="请输入内容" v-model="searchObj.title" class="input-with-select">
						<el-button slot="append" type="primary"  @click="search">查询</el-button>
					</el-input>
					
				</div>
			</div>
		</div>
		<div style="color: red;" v-if="total_time">课程总时长：{{ total_time }}</div>
		<div :class="classNames+ '_search_con_item'" style="margin-bottom: 20px;margin-top:20px;display:flex;justify-content:space-between;font-size: 14px">
			<div>
				<el-button v-if="!isHidden" style="transform: translateY(3px);" @click.prevent.stop="batchGrounding" size='mini' type="danger">批量上架</el-button>
				<el-button v-if="!isHidden" style="transform: translateY(3px);" @click.prevent.stop="batchDelisting" size='mini' type="danger">批量下架</el-button>
			<el-button style="transform: translateY(3px);" @click.prevent.stop="batchTransferMask" size='mini' type="danger">批量转移</el-button>
			<el-button style="transform: translateY(3px);" @click.prevent.stop="batchDel" size='mini' type="danger">批量删除</el-button>
			</div>
			<p style="color:red">单课程上传章节上限为2000个</p>
		</div>
		<div :class="classNames+ '_con_content'">
		
    <div :class="classNames+'_con_grouping'">
		
      <el-table  v-if="isGrouping" :row-class-name="rowClass" id="group_id" :data="groupList" :header-cell-style="{background: '#F5F7FA',color:'#454D53','height':'59px'}">
		   <template slot="empty">
            <div style="height:0px;"></div>
          </template>
        <el-table-column class="opop" label="章节分组" prop="a">
          <template slot="header">
            <span>章节分组</span>
            <el-popover placement="right-end" trigger="hover">
              <img src="http://img-dbzd.doubaozhidao.com/20220815/RkaYwWk4E4pjW8dRmbJeE7Xbc75KWWda1660554235280.png?x-oss-process=image/quality,q_80/format,png" />
              <span slot="reference" :class="classNames+'_operation_title'" style="margin-left:12px">查看示例?</span>
            </el-popover>
          </template>
		 
          <template slot-scope="scope">
				  <el-tooltip :disabled="scope.row.name.length<7" class="item" effect="dark" :content="scope.row.name" placement="right">

			  <div class="grouping-class" style="">
				  <div class="drag-handles-grouping move">
					  <p>拖动排序</p>
				  </div>
					<div class="chaochu">{{scope.row.name}}</div>
				  
				  <div class="ji-xiu" @click="changeGroup(scope.row.id,scope.$index)">
					<i @click.prevent.stop="moveDelete(scope.row)" style="cursor:pointer;" class="el-icon-delete compile-icon"></i>
            		<i @click.prevent.stop="renGroup(scope.row)" style="cursor:pointer;" class="el-icon-edit-outline compile-icon"></i>
				  </div>

				  <div>
					
				  </div>
			  </div>
					</el-tooltip>

            
          </template>
		  
        </el-table-column>
      </el-table>
      
		<div :class="{'active-hr':this.activeGroupingItem==0}" @click="changeGroup(0,groupList.length)" class="tab-item">
        未分组
      </div>
    </div>

		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table v-loading="loading"  v-if="isSection" id="list_id" :data="!uploadList.length? chapterList.list : [...uploadList, ...chapterList.list]"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :cell-class-name="cellClassName" :span-method="arraySpanMethod">
				<!-- 	<el-table-column type="index" label="排序">
					</el-table-column> -->
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<!-- 拖拽句柄 -->
					<el-table-column width="55">
						<template slot="header">
						</template>
						<template slot-scope="scope">
							<div class="drag-handles-chapter move">
								<p v-if="scope">拖 <br>动<br>此<br>处<br>排<br>序<br></p>
							</div>
						</template>
					</el-table-column>

					
					<!-- 复选框 -->
					<el-table-column width="55">
						<template slot="header">
							<el-checkbox v-model="checkAll" @change="(value)=>changeCheckboxAll(value)" :indeterminate="immediateFlag"></el-checkbox>
						</template>
						<template slot-scope="scope">
							<el-checkbox :value="isCheckboxArr.includes(scope.row.id)" @change="(value)=>changeCheckbox(value,scope.row)" :disabled="scope.row.is_transcode == 2">
							</el-checkbox>
						</template>
					</el-table-column>
					<!-- 排序 -->
					<el-table-column width="75">
						<template slot="header">
							<div class="sort-div">
							<div>排序</div>
								<span @click="sortDef" style="transform: translateY(3px);" class="caret-wrapper">
									<i :class="{'active-ascending':isSort=='asc'}" class="sort-caret ascending"></i>
									<i :class="{'active-descending':isSort=='desc'}" class="sort-caret descending"></i>
								</span>
							</div>
						</template>
						<template slot-scope="scope">
							<div @click="clickSort(scope.row,sortIndex(scope.row.id))" style="width:50px;text-align: center;padding-right: 15px;box-sizing: border-box;">
								{{sortIndex(scope.row.id)}}
								<i style="cursor:pointer;" class="el-icon-edit-outline compile-icon"></i>
							</div>
						</template>
					</el-table-column>
		
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width" :sortable='item.sortable' :align="item.align">

						<template slot-scope="scope">
							<uploadFile :ref="'upload_'+ scope.row.id" :multiple="multiple" :isCancelFlag="true" uploadSize="2gb" @change="(list)=> {successFile(list, scope.row)}" @uploadSucess="(list, item)=> {uploadSucess(list,item, scope.row)}" @beforeUpload="(list) => { beforeUpload(list,scope.row) }" :accept="accept" :uploadType="uploadType"></uploadFile>
							<template v-if="item.prop === 'chapterObj'" >
								<div :class="classNames+ '_table_imgtitle'" v-if="scope.row.status">
									<div :class="[classNames+ '_table_imgtitle_con', {[classNames+ '_table_imgtitle_edit']: scope.row.status !== 3}]">
										<!-- <div :class="classNames+ '_table_imgtitle_left'">
											<img src="http://img-dbzd.doubaozhidao.com/20220815/kxWs5hxjjTy2Jp3EKf5F2ASZznniWee51660554235285.png?x-oss-process=image/quality,q_80/format,png" v-if="scope.row.ptype == 3 || scope.row.ptype == 4"/>
											<img src="http://img-dbzd.doubaozhidao.com/20220815/6bSMNwiis6im2aY4E3B75XswChjNKAXd1660554235287.png?x-oss-process=image/quality,q_80/format,png" v-else-if="scope.row.ptype == 2"/>
											<img src="http://img-dbzd.doubaozhidao.com/20220815/sJX3jj6krwHR7MEXS5BmHrSE5QtxaTtX1660554235287.png?x-oss-process=image/quality,q_80/format,png" v-else/>
											<span v-if="scope.row.ptype !=5" class="duration">{{scope.row.duration}}</span>
											<tagsList :data="scope.row.come_from"></tagsList>
											<div class="repace_class">
												<el-button type="primary" size="mini" @click="()=> {createClass(scope.row)}">更换内容</el-button>
											</div>
										</div> -->
										<div :class="classNames+ '_table_imgtitle_right'" v-if="!isHidden">
											<div :class="classNames+ '_table_right_bot'">
												<div :class="classNames+ '_table_bot_status'">
													<span :class="classNames+ '_table_bot_status_tit'" v-statusColor="{status: scope.row.status, list: selectList}"></span>
													<!-- <el-tooltip :content="scope.row.reason" placement="top" v-if="scope.row.reason">
														<span :class="classNames+ '_table_bot_reason'">下架/驳回原因</span>
													</el-tooltip> -->
													<el-popover
														placement="top"
														title="下架/驳回原因"
														width="700"
														trigger="hover"
														popper-class="reject-reason-wrap"
														>
														<div style="max-height: 600px;display:flex;flex-direction:column">
															<div v-html="scope.row.reason" class="reject-reason">
															</div>
														</div>
														<span :class="classNames+ '_table_bot_reason'"  v-if="scope.row.reason" slot="reference">下架/驳回原因</span>
													</el-popover>
													<el-tooltip :content="scope.row.reject" placement="top" v-if="scope.row.reject">
														<span :class="classNames+ '_table_bot_reason'">更新驳回原因</span>
													</el-tooltip>
													<span :class="classNames+ '_table_bot_reason'" v-if="scope.row.update_status">{{scope.row.update_status}}</span>
												</div>
												<div :class="classNames+ '_table_bot_time'">
													{{scope.row.created_time}}
												</div>
											</div>
										</div>
									</div>
									<el-progress :percentage="scope.row.process" color="#4e70f2" style="margin-top: 12px" v-if="scope.row.process || scope.row.process === 0"></el-progress>
								</div>
								<!-- 进度条 -->
								<div :class="classNames+'_process'" v-else>
									<div :class="classNames+'_process_con'">
										<span>{{scope.row.name}}</span>
										<span v-if="scope.row.process === 0 || scope.row.process">{{scope.row.process}}%</span>
									</div>
									<div style="display: flex;align-items:center"  v-if="scope.row.process === 0 || scope.row.process">
										<el-progress :percentage="scope.row.process" :show-text="false" :color="scope.row.type == 'error' ? 'red' : '#4e70f2'" style="flex:1;margin-right:16px"></el-progress>
										<i
											class="iconfont"
											style="cursor: pointer;font-size:18px;color: red;"
											@click="reloadFile(scope.row, scope.$index)"
											v-if="scope.row.type == 'error'"
											>&#xe620;</i
										>
										<i class="el-icon-delete" v-if="scope.row.type == 'error'" style="cursor: pointer;font-size:18px;color: red;margin-left: 12px" @click="delErrorUpload(scope.$index)"></i>
									</div>
									<div style="color:red;display: flex;align-items:center;justify-content:space-between;font-size:18px" v-if="scope.row.process ==='' && scope.row.type == 'error'">
										<span>上传章节失败,请删除后重新上传</span>
										<i class="el-icon-delete" @click="delErrorUpload(scope.$index)"></i>
									</div>
								</div>
							</template>
							<div v-else-if="item.type === 'input'">
								<!-- scope.row.status课程状态 -->
								<span v-if="scope.row.status == 3 || Number.isInteger(scope.row.process)" @click="copyUrl2(scope.row)" style="margin-left:16px">{{scope.row[item.prop]}}</span>
								<template v-else>
									<!--  -->
									<!-- <el-input :placeholder="item.placeHolder" v-model="scope.row[item.prop]" :class="{[classNames + '_input_error']: scope.row[item.prop+ '_errorTitle']}" @blur="()=> {handleTitleBlur(scope.row, item)}" @input="()=> {handleTitleChange(scope.row, item)}" :ref="'title'+ scope.row.id" spellcheck="false"/> -->

									<span class="filter moni-input" @click.prevent.stop="seiTitleFn(scope,item)">{{scope.row[item.prop]}}
										<i style="cursor:pointer; margin-left:20px;" class="el-icon-edit-outline compile-icon "></i>
									</span>
									

									<!-- <el-input :placeholder="item.placeHolder" v-model="scope.row[item.prop]" :class="{[classNames + '_input_error']: scope.row[item.prop+ '_errorTitle']}" @blur="()=> {handleTitleBlur(scope.row, item)}" @input="()=> {handleTitleChange(scope.row, item)}" :ref="'title'+ scope.row.id" spellcheck="false"/> -->
										<span :class="classNames+'_error_title'" v-if="scope.row[item.prop+ '_errorTitle']">{{scope.row[item.prop+ '_errorTitle']}}</span>
								</template>
								<!-- !scope.row[item.prop] &&scope.row.status -->
								<!-- {[classNames+'_error_title']: !scope.row[item.prop]} -->
							</div>
							<div v-else-if="item.prop=='ptype'">
								{{scope.row[item.prop] | filterType}}
								<div v-if="scope.row.fileType == 3 || scope.row.fileType == 4" class="video-screen">
									<el-radio-group v-model="scope.row.fileType" @change="(value)=> changeFileType(scope.row, value)">
										<el-radio :label="3">横屏</el-radio><br>
										<el-radio style="margin-top:10px !important; " :label="4">竖屏</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div v-else>{{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
				
					<el-table-column label="操作" align="right">
						<template slot-scope="scope">
							<span :class="classNames+'_operation_title'" @click="transferGrouping(scope.row)">转移</span>
							<span :class="classNames+'_operation_title'" @[transcodeEventType({transcode:scope.row.is_transcode})]="()=> {createClass(scope.row)}"  v-if="scope.row.status!=3">更换内容</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="editStatus(scope.row)" :class="[classNames+'_operation_title', {'transcode_title_disabled':scope.row.is_transcode == 2}]" v-if="handleShow(scope.row.status, 1) && !isHidden">下架</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="editStatus(scope.row)" :class="[classNames+'_operation_title',{'transcode_title_disabled':scope.row.is_transcode == 2}]" v-if="handleShow(scope.row.status, 2) && !isHidden">上架</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="editStatus(scope.row)"
								:class="[classNames+'_operation_title', {'transcode_title_disabled':scope.row.is_transcode == 2}]" v-if="scope.row.status == 4 && !isHidden">上架</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="preview(scope.row)" :class="[classNames+'_operation_title',{'transcode_title_disabled':scope.row.is_transcode == 2}]" v-if="scope.row.url || scope.row.image_text">预览</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="deltes(scope.row)" :class="[classNames+'_operation_title',{'transcode_title_disabled':scope.row.is_transcode == 2}]" v-if="handleShow(scope.row.status, -1)">删除</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="recall(scope.row)" :class="[classNames+'_operation_title',{'transcode_title_disabled': scope.row.is_transcode == 2}]" v-if="handleShow(scope.row.status, 6) && !isHidden">撤回</span>
							<span @[transcodeEventType({transcode:scope.row.is_transcode})]="transcode(scope.row.id, $route.params.id,'getShowlists')" :class="[classNames+'_operation_title',{'transcode_title_disabled': scope.row.is_transcode == 2}]" v-if="scope.row.is_video == 1 && !isHidden">{{scope.row.is_transcode == 1 ? '转码': '转码中'}}</span>
							<span :class="classNames+'_operation_title'" @click="isFree(scope.row)">{{scope.row.free == -1? '设为试看' : '取消试看'}}</span>

						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination layout="sizes, prev, pager, next, jumper , total" :pageSize="searchObj.page_size" :pageSizes='[10,20,50]' @sizeChange="sizeChange" @change="changeSize" :value='4' :total="chapterList.total" ref="pagination" v-model="searchObj.page" v-if="chapterList.total > 10"></Pagination>
			<submit-dialog :editParams="editParams" v-model="dialogVisible" @sure="sureClick"></submit-dialog>
			<el-dialog
				:modal-append-to-body="false"
				title="请选择内容类型"
				:visible.sync="contentFlag"
				width="500px"
				:custom-class="classNames+'_dialog_type'"
				 top="400px"
				>
					<div style="color:red;margin-top: -30px;font-size: 16px;margin-left: 10px;">音视频时长需大于{{chapterList.mix_time}}分钟</div>
					<div class="btn_list">
						<el-button  @click="changeSuCai('sucaiFlag', 1)">
							<span>视频</span>
						</el-button>
						<el-button @click="changeSuCai('sucaiFlag', 2)">
							<span>音频</span>
						</el-button>
						<el-button @click="changeSuCai('sucaituwenFlag', 3)">
							<span>图文</span>
						</el-button>
					</div>
					<div style="color:red">
						建议一次最多同时上传20个内容
					</div>
			</el-dialog>
			<video-sucaiDialog v-model="sucaiFlag" :multiple="multiple" dialogWidth="1060px" :isNeedHuoSanUrlFlag="true" :addNumber="0" :limit="8" :isUploadFlag="false" uploadSize="2gb" @changeProcess="successFile" @uploadLocal="uploadLocal" @sureClick="sureMaterial" @uploadSucess="uploadSucess" @beforeUpload="beforeUpload" ref="material" :isCancelUploadFlag="false" :accept="accept" :uploadType="uploadType" :iscustomFlag="row?true:false" :btnTitle="uploadType == 'video'?'播放':''"></video-sucaiDialog>
			<!-- 设置排序 -->
			<el-dialog :visible.sync="isSortMask" top="400px" title="章节排序" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" :modal='false'  @mousedown.native.stop="" @mouseup.native.stop="">
				<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="() => {}"></div>
				<el-input type="number" placeholder="请输入排序值" :min="1" v-model="orderValue"/>
				<div style="margin-top:20px;color:red;">请输入排序值，数字越小越靠前</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click.prevent.stop="isSortMask = false">取 消</el-button>
					<el-button type="primary" @click.prevent.stop="theInputValueSorting()" :disabled="!orderValue">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog :visible.sync="sucaituwenFlag" top="50px" title="图文" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true">
				<el-form :model="imgTextForm" :rules="imgTextRules" ref="imgText" label-width="60px">
					<el-form-item prop="title" label="标题">
						<el-input placeholder="请输入章节标题" v-model="imgTextForm.title" />
					</el-form-item>
					<el-form-item prop="image_text" label="内容">
						<quill-editor v-model="imgTextForm.image_text" :height="400" :key="sucaituwenFlag" :menuList="imgTextMenuList" :placeholder="staticPath=='/'?'抖音图文课程支持图片/文字':'请输入正文'" @input="onquillInput">
						</quill-editor>
						<span style="color:red" v-if="staticPath === '/'">图文类型履约请使用图片格式上传</span>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="sucaituwenFlag = false">取 消</el-button>
					<el-button type="primary" @click="imgTextSure('imgText')">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog :visible.sync="groupFlag" top="400px" title="添加分组" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" :modal='false'  @mousedown.native.stop="" @mouseup.native.stop="">
				<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="() => {}"></div>
				<el-input placeholder="请输入分组名称" v-model="groupName" @input="groupInpChange" :class="{[classNames + '_input_error']: groupName_errorTitle}"/>
				<span :class="classNames+'_error_title'" style="left:20px" v-show="groupName_errorTitle">{{groupName_errorTitle}}</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click.prevent.stop="groupFlag = false">取 消</el-button>
					<el-button type="primary" @click.prevent.stop="addGroupSure" :disabled="!groupName">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 重命名列表title -->
				<el-dialog :visible.sync="seiTitle"  top="400px" v-if="seiTitle" title="编辑标题" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" :modal='false'  @mousedown.native.stop="" @mouseup.native.stop="">
					<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="() => {}"></div>
					<el-input :placeholder="setTitleObj.item.placeHolder" v-model="setTitleObj.scope.row[setTitleObj.item.prop]" :class="{[classNames + '_input_error']: setTitleObj.scope.row[setTitleObj.item.prop+ '_errorTitle']}" @input="()=> {handleTitleChange(setTitleObj.scope.row, setTitleObj.item)}" :ref="'title'+ setTitleObj.scope.row.id" spellcheck="false"/>
					<span :class="classNames+'_error_title'" style="margin-left:15px;" v-show="setTitleObj.scope.row[setTitleObj.item.prop+ '_errorTitle']">{{setTitleObj.scope.row[setTitleObj.item.prop+ '_errorTitle']}}</span>

					<span :class="classNames+'_error_title'" style="left:20px" v-show="groupName_errorTitle">{{groupName_errorTitle}}</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click.prevent.stop="seiTitle = false">取 消</el-button>
						<el-button type="primary" @click.prevent.stop="handleTitleBlur(setTitleObj.scope.row, setTitleObj.item)">确 定</el-button>
					</span>
				</el-dialog>
			
			<el-dialog :visible.sync="delGroupFlag" title="提示" :center="true" :custom-class="classNames+ '_group_dialog'" :modal='false' @mousedown.native.stop="" @mouseup.native.stop="" width="360px">
				<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="delGroupFlag = false"></div>
				<p style="text-align:center">确定要删除吗</p>
				<span slot="footer" class="dialog-footer">
					<el-button @click="delGroupFlag = false">取 消</el-button>
					<el-button type="primary" @click="delGroupSure">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 章节排序 -->
			<el-dialog :visible.sync="renGroupMask" top="400px" title="编辑分组" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" :modal='false'  @mousedown.native.stop="" @mouseup.native.stop="">
				<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="() => {}"></div>
				<el-input placeholder="请输入分组名称" v-model="groupName" @input="groupInpChange" :class="{[classNames + '_input_error']: groupName_errorTitle}"/>
				<span :class="classNames+'_error_title'" style="left:20px" v-show="groupName_errorTitle">{{groupName_errorTitle}}</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click.prevent.stop="renGroupMask = false">取 消</el-button>
					<el-button type="primary" @click.prevent.stop="addGroupSure(renGroupItem)" :disabled="!groupName">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog :visible.sync="delGroupFlag" title="提示" :center="true" :custom-class="classNames+ '_group_dialog'" :modal='false' @mousedown.native.stop="" @mouseup.native.stop="" width="360px">
				<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="delGroupFlag = false"></div>
				<p style="text-align:center">确定要删除吗</p>
				<span slot="footer" class="dialog-footer">
					<el-button @click="delGroupFlag = false">取 消</el-button>
					<el-button type="primary" @click="delGroupSure">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 迁移分组单个 -->
			<el-dialog :visible.sync="moveGroup" title="" top="400px" width="450px" height="300px" :close-on-click-modal="false" :close-on-press-escape="false"
				:modal='true'>
				<div >
				<div style="display: flex;align-items: center;justify-content: space-around;">
					<div>
						请选择转移到分组
					</div>
					<el-select v-model="transferType" :class="{'dis-none':!moveGroup}" popper-class="loadMoreSelect" placeholder="请选择分组" @blur="closeGroupMask"
						@change="(value) => transferFn(value, transferRow)">
						<el-option v-for="(item) in groupList" :key="item.id" :value="item.id" :label="item.name">
							<div :class="classNames+'_group'">
								<p>{{item.name}}</p>
							</div>
						</el-option>
						<el-option :value="0" label="未分组">
							<div style="width:200px;height:40px;" @click="(value) => transferFn(0, transferRow)">
								未分组
							</div>
						</el-option>
					</el-select>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-around;height: 130px;">
				</div>
				</div>

			</el-dialog>
			<!-- 迁移分组批量 -->
			<el-dialog :visible.sync="moveGroupTwo" title="" top="400px" width="450px" height="300px" :close-on-click-modal="false" :close-on-press-escape="false"
				:modal='false'>
				<div >
				<div style="display: flex;align-items: center;justify-content: space-around;">
					<div>
						请选择转移到分组
					</div>
					<el-select popper-class="loadMoreSelect" placeholder="请选择分组" @blur="closeGroupMask"
						@change="(value) => transferFnTwo(value, transferRow)" v-model="transferType">
						<el-option v-for="(item) in groupList" :key="item.id" :value="item.id" :label="item.name">
							<div :class="classNames+'_group'">
								<p>{{item.name}}</p>
							</div>
						</el-option>
						<el-option :value="0">
							<div @click="(value) => transferFnTwo(0, transferRow)">
								未分组
							</div>
						</el-option>
					</el-select>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-around;height: 130px;">
				</div>
				</div>

			</el-dialog>
			<el-dialog :visible.sync="previewFlag" title="" width="500px" :custom-class="classNames+'_preview_dialog'" :destroy-on-close="true" :before-close="previewMediaClose">
				<template v-if="row.ptype == 3 ||row.ptype == 4">
					<video  id="my-player" class="video-js" preload="auto" data-setup='{}' controls  style="max-height: 70vh;width: 100%; margin: 0 auto; display: block" v-if="previewFlag" autoplay ref="previewVideo">
						<source :src="row.url"></source>
					</video>
				</template>
				<template v-else-if="row.ptype == 2">
					<Audio :url="row.url" :duration="changeSecond(row.duration)"  v-if="previewFlag"></Audio>
				</template>
				<div v-html="row.image_text" v-else class="img_text"></div>
			</el-dialog>
		</div>
		</div>
		
		<div v-if="isHidden" style="margin-top:18px;display:flex; align-items: center;">
			<el-button @click="goBack">上一步</el-button>
			<el-button type="primary" @click="launchAudit" :disabled="chapterList.list.length==0" style="margin-right:30px;">上架审核</el-button>
			<div class="read">
				<div class="remberPass"><el-checkbox v-model="isread">阅读并同意</el-checkbox></div>
				<span @click="watchAgreement">《豆包知道内容上传协议》</span>
			</div> 
		</div>
	</div>
</template>

<script>
	import {
		data
	} from './data.js'
	import { common } from '../../../mixin/common.js'
	import {
		mapState,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import transcode from '@/components/mixin/mixin.js'
	import SucaiDialog from '@/components/sucaikuDialog/sucaikuDialog.vue'
	import quillEditor from '@/components/quillEditor/quillEditor.vue'
	import Audio from '@/components/audio/audio.vue'
	import uploadFile from '@/components/newUpload/upload.vue'
	import axios from 'axios'
	import Sortable from 'sortablejs'
	import staticPathTitle,{ getAliFileUploadUrl } from '@/utils/baseUrl.js'
	import videojs from "video.js"
	import dayjs from 'dayjs'
	import duration from 'dayjs/plugin/duration'
	import { debounce } from 'lodash-unified'
	dayjs.extend(duration)

	export default {
		name: 'Chapter',
		mixins: [data, common, transcode],
		data() {
			let id = this.$route.params.id
			const keywordRule = (rule, value, callback,title) => {
				if(value === '') {
					callback(new Error(title))
				} else {
					if(rule.field == 'image_text') {
						if(this.staticPath === '/' && value.length > 50000) {
							callback(new Error('内容限制50000字以内'))
						}
						let Div = document.createElement('div')
						Div.innerHTML = value
						Div.style = 'display:none'
						document.body.appendChild(Div)
						let htmlText = Div.innerText
						value = htmlText
						document.body.removeChild(Div)
					}
					let keyWords = this.keyWordList.find(item => value.toLocaleLowerCase().replace(/\s|\&nbsp\;/g,"").includes(item.toLocaleLowerCase().replace(/\s/g,"")))
					let platformType = staticPathTitle[this.staticPath].label
					if(keyWords) {
						callback(new Error(keyWords + '为' + platformType + '敏感词请更换'))
					}
					callback()
				}
			}
			return {
				classNames: 'chapter',
				getGroupAll: false,
				groupObj: {
					page: 1,
					name: '',
					product_id: id,
					page_size: 10
				},
				searchObj: {
					status: '',
					group_id: '',
					title: '',
					page: 1,
					page_size: 10,
					id
				},
				contentFlag: false,
				sucaiFlag: false,
				sucaiAudioFlag: false,
				sucaituwenFlag: false,
				uploadList: [],
				chapterList: {
					list: [],
					total: 0,
					mix_time: 0
				},
				promiseList: [],
				promiseSuCaiList:[],
				type: '',
				
				imgTextForm: {
					title: '',
					image_text: ''
				},
				imgTextRules: {
					title: [
						{ 
							required: true,
							// message: '请输入章节标题',
						  	trigger: 'blur', 
						  	validator: (rule, value, callback) =>  {
								keywordRule(rule, value, callback,'请输入章节标题')
							} 
						}
					],
					image_text: [
						{ 
							required: true, 
							// message: '请输入内容',
						 	trigger: 'blur',
							validator: (rule, value, callback) =>  {
								let Div = document.createElement('div')
								Div.innerHTML = value
								Div.style = 'display:none'
								document.body.appendChild(Div)
								let htmlText = Div.innerText
								document.body.removeChild(Div)
								keywordRule(rule, value, callback,'请输入内容')
							} 
						}
					]
				},
				uploadLen: 0,
				groupName: '',
				groupFlag: false,
				groupList: [],
				groupId: '',
				delGroupFlag: false,
				// classId: '',
				previewFlag: false,
				multiple: true,
				keyWordList: [],
				groupName_errorTitle: '',
				moveGroup:false,//转移分组弹窗  单个
				moveGroupTwo:false,//转移分组弹窗  批量

				transferRow:'',//正在转移的分组数据

				renGroupMask:false,//重命名分组弹窗开关
				renGroupItem:'',//正在重命名的列表项数据item
				
				isCheckboxArr:[],//选中的id
				checkAll:false,//全选开关

				isGrouping:true,//分组列表开关
				isSection:true,//章节列表开关

				isSort:'asc',//asc正序 desc倒序

				activeGroupingItem:0,//正在激活的分组
				seiTitle:false,
				setTitleObj:{
					scope:'',
					row:''
				},
				loading:true,//
				copy_sort1:'',//排序后的数据   分组
				copy_sort2:'',//排序后的数据   章节

				isSortMask:false,//排序弹窗
				orderValue:'',//输入的排序值
				sortRow:'',//正在排序的row
				pageScroll:'',//
				computedUploadList: [],
				copyTypeNum: '',
				transferType: '',
				isread: false,
				total_time: 0
			}
		},
		created() {
			this.getSensitiveFun()
			// this.setLoadMore()
			this.searchGroupData().then(res=>{
				if(this.groupList.length>0){
				this.searchObj.group_id=this.groupList[0].id
				this.activeGroupingItem=this.groupList[0].id
				}else{
				this.searchObj.group_id=0
				}
				this.getShowlists()//章节数据

			})
		},
		mounted(){
			// this.rowDrop()
		},
		components: {
			Pagination,
			'video-sucaiDialog': SucaiDialog,
			'audio-sucaiDialog': SucaiDialog,
			'quill-editor': quillEditor,
			Audio,
			uploadFile
		},
		computed: {
			...mapState(['breadCrumbList']),
			// ...mapState('chapter',['groupList']),
			isHidden() {
				return this.$route.params.type == 'column'
			},
			accept() {
				let obj = {
					1: ['.mp4','.mov'],
					2: ['.mp3']
				}
				return obj[this.type] || []
			},
			uploadType() {
				let obj = {
					1:  'video',
					2: 'audio'
				}
				return obj[this.type]
			},
			eventType() {
				return (value) =>  {
					return value ? 'blur': ''
				}
			},
			modelType() {
				return 'v-model.number'
			},
			sortNum(){
				
			},
			sortIndex(){
				return (id) => {
					let index=this.copy_sort2.findIndex(item=>item.id==id)
					if(index==-1){
						return 1
					}
					if(this.isSort=='asc') {
						return this.searchObj.page_size*(this.searchObj.page-1)+index+1 
					} else {
						return this.chapterList.total-index-this.searchObj.page_size*(this.searchObj.page-1)
					}
				}
			},
			isReshList() {
				return [this.promiseList, this.computedUploadList]
			},
			immediateFlag() {
				return this.chapterList.list.length === this.isCheckboxArr.length || this.isCheckboxArr.length === 0? false: true
			},
			// 图文富文本菜单
			imgTextMenuList(){
				if(this.staticPath === '/'){
					return ['image','undo','redo']
				}else{
					return [
						'head',
						'bold',
						'fontSize',
						'italic',
						'underline',
						'strikeThrough',
						'lineHeight',
						'backColor',
						'justify',
						'quote',
						'image',
						'table',
						'undo',
						'redo',
					]
				}
			}
		},
		methods: {
			...mapActions('chapter', ['getShowlist', 'showrecall']),
			...mapActions('newChapter',['createdshow', 'showlist']),
			...mapActions('group', ['groupsort','sectionsort', 'addgroupFun', 'getGroupList', 'groupRemove']),
			...mapActions('class', ['showUpdate', 'createdallshow', 'getSensitive']),
			onquillInput:debounce(function(e){
				// if(this.staticPath=='/'){
				// 	this.isHaveTextFn(e)
				// }
			},400),
			// 判断是否有文字
			isHaveTextFn(richTxt){
				richTxt = richTxt.replace(/<(?!img).*?>/g, "")
				richTxt = richTxt.replace(/<img.*?(?:>|\/>)/g, "")
				console.log('richTxt：',richTxt)
				if(richTxt.length && this.sucaituwenFlag){
					this.$message({
						showClose: true,
						message: '抖音图文课程仅支持图片，请删除文字部分',
						type: 'error'
					});
					return true
				}else{
					return false
				}
			},
			//setTheSort
			setTheSort(){

			},
			clickSort(row,orderValue){
				this.isSortMask=true
				this.sortRow=row
				this.orderValue=orderValue
			},
			rowClass(row){
				if(row.row.id==this.activeGroupingItem){
					return 'active-hr'
				}
			},
			seiTitleFn(scope,item){
				this.seiTitle=true
				this.setTitleObj={scope,item}
				console.log(123,this.setTitleObj);
				
			},
			changeCheckbox(value,row){
				if(value) {
				this.isCheckboxArr.push(row.id)
				}else{
					let index=this.isCheckboxArr.findIndex(item=>item==row.id)
					if(index>=0){
						this.isCheckboxArr.splice(index,1)
					}
				}
				console.log(123,value,this.isCheckboxArr);
			},
			changeCheckboxAll(value){
				if(value) {
					console.log(this.chapterList.list)
					this.isCheckboxArr= this.chapterList.list.reduce((pre, item) => {
					if(item.is_transcode !== 2) {
						pre.push(item.id)
					}
					return pre
				}, [])
				}else{
					this.isCheckboxArr=[]
				}
			},
			batchGrounding(){//批量上架
				if(!(this.isCheckboxArr.length>0)){
					this.$message({
					message: '请选择章节',
					type: 'error',
					duration: 3000
				})

					return
				}
				this.$confirm('是否确认批量上架？', '提示', {
					distinguishCancelAndClose: false,
					confirmButtonText: '是',
					cancelButtonText: '否',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(() => {
					this.batchSureClick(1)
				})
			},
			batchDelisting(){ // 批量下架
				if(!(this.isCheckboxArr.length>0)){
						this.$message({
						message: '请选择章节',
						type: 'error',
						duration: 3000
					})
					return
				}
				this.$confirm('是否确认批量下架？', '提示', {
					distinguishCancelAndClose: false,
					confirmButtonText: '是',
					cancelButtonText: '否',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(() => {
					this.batchSureClick(-2)
				})
			},
			closeGroupMask(){//关闭转移弹窗
				this.moveGroup = false
				this.moveGroupTwo=false
			},
			transferFn(value){//转移  弹窗
				if(this.transferType !== '') {
					this.editGroup(value, this.transferRow)
				}
				this.transferType = ''
			},
			transferFnTwo(value){//转移 批量
				if(this.transferType !== '') {
					this.batchTransferNet(value)
				}
				this.transferType = ''
			},
			batchTransferMask(){
				if(this.isCheckboxArr.length>0){
					this.moveGroupTwo=true
				}else{
					this.$message({
					message: '请选择章节',
					type: 'error',
					duration: 3000
				})
				}
				
			},
			async batchTransferNet(value){//批量请求
				await this.createdshow({
					group_id: value,
					product_id: this.$route.params.id,
					id: this.isCheckboxArr.join(',')
				})
				await this.getShowlists()
				this.$message({
					message: '修改分组成功',
					type: 'success',
					duration: 3000
				})
			},
			batchDel(){//批量删除
			if(!(this.isCheckboxArr.length>0)){
					this.$message({
					message: '请选择章节',
					type: 'error',
					duration: 3000
				})
				return
				}
			let contentText='确定要删除吗？'
			this.chapterList.list.forEach((item,index)=>{
				if(item.status==1||item.status==3){
				let isIn=this.isCheckboxArr.indexOf(item.id)
					if(isIn!=-1){
						contentText='所选章节里包含已上架或审核中内容（上架或审核中内容无法删除）是否继续执行删除操作？'
						// this.isCheckboxArr.split(isIn,1)
					}
				}
			})
			this.$confirm(contentText, '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					try{
					await this.createdshow({ id: this.isCheckboxArr.join(','), product_id: this.$route.params.id, status: -1 })
					this.$message(
						{
							type: 'success',
							message: '删除成功',
							duration: 3000
						}
					)
						this.getShowlists()

					}catch(err){
						this.getShowlists()

					}
				})
			},
			sortDef(column){//排序回调
				if(this.isSort=='asc'){
					this.isSort='desc'
				}else{
					this.isSort='asc'
				}
             this.getShowlists('','sort',this.isSort)
			},
			transferGrouping(row){//转移分组
				this.transferRow=row
				this.moveGroup=true
			},
			copyUrl2(row){
			console.log(1234,row.copy_title);
			this.copyToClipboard(row.copy_title); 
			this.$message({
					message: '复制成功',
					type: 'success',
					duration: 3000
				})
			},
			copyToClipboard(content){
				//window.clipboardData的作用是在页面上将需要的东西复制到剪贴板上，
				//提供了对于预定义的剪贴板格式的访问，以便在编辑操作中使用。
			if (window.clipboardData) {
				/*
				window.clipboardData有三个方法:
				（1）clearData(sDataFormat) 删除剪贴板中指定格式的数据。sDataFormat:"text","url"
				（2）getData(sDataFormat) 从剪贴板获取指定格式的数据。 sDataFormat:"text","url"
				（3）setData(sDataFormat, sData) 给剪贴板赋予指定格式的数据。返回 true 表示操作成功。
				*/
				window.clipboardData.setData('text', content);
			} else {
				(function (content) {
				//oncopy 事件在用户拷贝元素上的内容时触发。
				document.oncopy = function (e) {
					e.clipboardData.setData('text', content);
					e.preventDefault(); //取消事件的默认动作
					document.oncopy = null;
				}
				})(content);
				//execCommand方法是执行一个对当前文档/当前选择/给出范围的命令。
				//'Copy':将当前选中区复制到剪贴板。 
				document.execCommand('Copy');
			}
			},
						
			 //行拖拽
			rowDropOne() {
				const table = document.querySelector('#group_id tbody')
				const _this = this
				Sortable.create(table, { //记得引入sortable
				forceFallback: true, // ignore the HTML5 DnD behaviour and force the fallback to kick in
				handle:".move",
				onEnd({ newIndex, oldIndex }) {//后端替换失败记住请求接口刷新数据   本地数据不需要换
					let up=oldIndex
					let down=newIndex
					
				if(down!= up){
					console.log(123,down, up);
					console.log(125);
					let idOne=_this.copy_sort1[up].id
					let idTwo=_this.copy_sort1[down].id
					_this.movelist(idOne,idTwo)
					// _this.isCheckboxArr=[]
					if(down < up){
						let item=_this.copy_sort1.splice(up,1)
						_this.copy_sort1.splice(down,0,item[0])
					}else{
						let item=_this.copy_sort1.splice(up,1)
						_this.copy_sort1.splice(down,0,item[0])
					}
					}
				}
				})
		
			},
			//行拖拽
			rowDropTwo() {
				const table2 = document.querySelector('#list_id tbody')
				const _this = this
				Sortable.create(table2, { //记得引入sortable
				forceFallback: true, // ignore the HTML5 DnD behaviour and force the fallback to kick in
				handle:".move",
				onEnd({ newIndex, oldIndex }) {
					console.log(12345,newIndex, oldIndex);
					let up=oldIndex
					let down=newIndex
					if(newIndex!= oldIndex){
					let idOne=_this.copy_sort2[up].id
					let idTwo=_this.copy_sort2[down].id
					_this.moveSectionlist(idOne,idTwo)

					
					let item=_this.copy_sort2.splice(up,1)
					_this.copy_sort2.splice(down,0,item[0])
					}
					
				}
				})
			},
			goBack() {
				let flag = this.uploadList.some(item => item.process || item.process == 0)
				if(flag) {
					this.$message({
						type: 'warning',
						message: '有课程正在上传中，请稍后',
						duration: 3000
					})
					return
				}
				this.$router.replace(this.staticPath + 'createColumn/'+ this.$route.params.id)
			},
			async launchAudit() {
				if(!this.isread) {
					this.$message({
						type: 'error',
						message: '请勾选豆包知道内容上传协议'
					})
					return
				}
				let flag = this.uploadList.some(item => item.process || item.process == 0)
				if(flag) {
					this.$message({
						type: 'warning',
						message: '有课程正在上传中，请稍后',
						duration: 3000
					})
					return
				}

				let flag1 = true
				let inputList = this.headerList.filter(item => item.type == 'input').map(item => item.prop)
				this.chapterList.list.forEach(item => {
					for (const key in item) {
						if (inputList.includes(key)) {//错误信息判断  停止
							if(item[key+'_errorTitle']) {
								flag1 = false
							}
						}
					}
					return item
				})
				if(!flag1) {
					return
				}
				await this.createdallshow({
					product_id: this.$route.params.id
				})
				this.$router.replace(this.staticPath + 'specialColumn')
			},
			uploadLocal() {
				this.$refs['upload_'+ this.row.id][0].uploadFile()
			},
			arraySpanMethod({ row, columnIndex }) {
				if(!row.status) {
					if(columnIndex == 0) {
						return [1,1]
					} else if(columnIndex == 5) {
						return[1, 6]
					} else {
						return [0,0]
					}
				}
				
			},
			repaceFile(row) {

			},
			async movelist(up_id,down_id) {//参数 up_id:手上拖着的id   down_id:拖到谁上面或下面
				try{
					await this.groupsort({
						product_id: this.$route.params.id,
						up_id,
						down_id,
					})
				}catch(err){
					this.searchGroupData()
				}
				
			},
			//输入值排序
			async theInputValueSorting() {//参数 up_id:手上拖着的id   down_id:拖到谁上面或下面
				try{
					this.pageScroll=this.getPageScrollY()
					console.log(9998,this.pageScroll);
					await this.sectionsort({
						product_id: this.$route.params.id,
						id:this.sortRow.id,
						new_sort:this.orderValue,
						group_id:this.searchObj.group_id
					})
					await this.getShowlists()
					this.isSortMask=false
					this.orderValue=''
					setTimeout(() => {
						this.getPageScrollY(this.pageScroll)
					}, 500);
					
					

					}catch(err){
					this.getShowlists()
					this.isSortMask=false
					this.orderValue=''

					}

			},
			getPageScrollY(top) {
			if (top || Number(top) == 0) { //设置垂直滚动值
				document.querySelector(".content_right_con_scrollbar .el-scrollbar__wrap").scrollTop=top
			} else { //获取垂直滚动值
				return document.querySelector(".content_right_con_scrollbar .el-scrollbar__wrap").scrollTop
			}
		},
			//拖拽排序
			async moveSectionlist(up_id,down_id) {//参数 up_id:手上拖着的id   down_id:拖到谁上面或下面
				try{
					await this.sectionsort({
						product_id: this.$route.params.id,
						up_id,
						down_id,
						group_id:this.searchObj.group_id
					})
					}catch(err){
						this.getShowlists()
					}
			},
			async moveup(item,index,type) {
				await this.groupsort({
					action: type,
					id: item.id,
					product_id: this.$route.params.id
				})
				this.groupList.splice(index, 1)
				if(type === 'up') {
					index--
					this.groupList.splice(index, 0, item)
				} else {
					index++
					this.groupList.splice(index, 0, item)
				}
			},
			delErrorUpload(index) {
				this.uploadList.splice(index, 1)
				this.computedUploadList.splice(index, 1)
				if(this.promiseList.length === this.computedUploadList.length) {
					this.reshList()
				}
			},
			async moveDelete(item) {
				this.groupId = item.id
				
				//删除分组钱判断分组中是否有数据
				let options=JSON.parse(JSON.stringify(this.searchObj))
				options.page = 1
				options.group_id = this.groupId

				let res = await this.showlist(options)
				if(res.list.length>0){
				this.$confirm('该分组下面有内容是否继续删除？', '提示', {
					distinguishCancelAndClose: false,
					confirmButtonText: '是',
					cancelButtonText: '否',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(() => {
				this.delGroupFlag = true
				})
				}else{
				this.delGroupFlag = true
				}
			},
			async delGroupSure() {
				await this.groupRemove({
					id: this.groupId,
					product_id: this.$route.params.id
				})
				if(this.activeGroupingItem==this.groupId){
					this.activeGroupingItem=0
					this.searchObj.group_id=this.activeGroupingItem
				}
				await this.getShowlists()
				let index = this.groupList.findIndex(item => item.id == this.groupId)
				this.groupList.splice(index, 1)
				this.delGroupFlag = false
				
				this.$message({
					type: 'success',
					message: '删除成功',
					duration: 3000
				})
			},
			changeSecond(value) {
				let formatObj = [
					{
						value: 1
					},
					{
						value: 60
					},
					{
						value: 3600
					}
				]
				if(value.includes(':')) {
					let valueList = value.split(':').filter(item => item).reverse()
					let i = 0
					let num = 0
					while(i< valueList.length) {
						num+=valueList[i] * formatObj[i].value
						i++
					}
					return num
				} else {
					return value
				}
			},
			handleDuration(value) {
				if(Number(value).toString() !== 'NaN') {
					let h = Math.floor(value / 3600 % 24).toString().padStart(2, 0)
					let m = Math.floor(value / 60 % 60).toString().padStart(2, 0)
					let s = (value% 60).toString().padStart(2, 0)
					return  h+ ':' + m+ ':' +s
				} else {
					return '00:00:00'
				}
        	},
			imgTextSure(name) {
				this.$refs[name].validate((valid) => {
					if(valid) {
						// if(this.staticPath === '/'){
						// 	if(this.isHaveTextFn(this.imgTextForm.image_text)){
						// 		return
						// 	}
						// }
						this.computedUploadList.push(this.imgTextForm)
						let params = {
							...this.imgTextForm
						}
						if(this.row) {
							let index =[...this.uploadList, ...this.chapterList.list].findIndex(obj => obj.id == this.row.id)
 							params.status =[...this.uploadList, ...this.chapterList.list][index].status
							params.chapterId =[...this.uploadList, ...this.chapterList.list][index].id
							this.$refs['upload_'+ this.row.id] && this.$refs['upload_'+ this.row.id][0].cancelUpload()
						}
						this.copyTypeNum = this.type
						this.isUpLoadFinsh(this.row,[params], 'url', 'image_text', 'title')
						this.sucaituwenFlag = false
						this.contentFlag = false
					}
				})
			},
			beforeUpload(list,row) {
				this.contentFlag = false
				this.uploadLen = list.length
				list.forEach(item => {
					item.fileTtpeNum = this.type
				})
				if(row) {
					this.sucaiFlag = false
					let indexs = this.computedUploadList.findIndex(item => item.id == row.id)
					if(indexs === -1) {
						list[0].id = row.id
						this.computedUploadList.push(...list)
					}
					let data = []
					if(row.isLocal) {
						data = this.uploadList
					} else {
						data = this.chapterList.list
					}
					let index= data.findIndex(item => item.id == row.id)
					if(index !== -1) {
						this.$set(data[index], 'process', list[0].process)
						this.$set(data[index], 'fileName', list[0].newFileName)
					}
				} else {
					this.uploadList.unshift(...list)
					this.computedUploadList.unshift(...list)
				}
			},
			reloadFile(row, index) {
				this.$refs.material.$refs.uploadFile.reloadFile(row)
			},
			async handleTitleBlur(row, item) {
				this.seiTitle=false
				if(row['copy_' + item.prop] == row[item.prop]) {
					return
				}
				if(row[item.prop + '_errorTitle']) {
					return
				}
				let requestType = row.status == 1? 'showUpdate': 'createdshow'
				await this[requestType]({
					[item.prop]: row[item.prop],
					product_id: this.$route.params.id,
					[requestType === 'showUpdate'? 'show_id': 'id']: row.id
				})
				if(row.status == 1 && item.prop == 'title') {
					this.$confirm('<p style="color:red">修改内容已提交审核，需平台审核后方可回显</p>', '信息', {
						dangerouslyUseHTMLString: true,
						distinguishCancelAndClose: false,
						showCancelButton: false,
						confirmButtonText: '确定',
						showClose: false,
						closeOnClickModal: false,
						closeOnPressEscape: false,
						customClass: this.classNames + '_common_dialog',
						center: true
					})
				}
				if(row.status == 1 || item.prop == 'sort') {
					this.getShowlists()
				}
			},
			testkeyWordRule(row, type, requiredTitle) {
				// let type = item.prop
				this.$set(row, type + '_errorTitle', '')
				if(!row[type]) {
					this.$set(row, type + '_errorTitle', requiredTitle + '不能为空')
				}
				let keyWords = this.keyWordList.find(obj => row[type].toString().toLocaleLowerCase().replace(/\s/g,"").includes(obj.toLocaleLowerCase().replace(/\s/g,"")))
				let platformType = staticPathTitle[this.staticPath].label
				if(keyWords) {
					this.$set(row, type + '_errorTitle', keyWords + '为' + platformType + '敏感词请更换')
				}
			},
			handleTitleChange(row, item) {
				this.testkeyWordRule(row, item.prop, item.requiredTitle)
			},
			changeSuCai(type, typeNum) {
				this.type = typeNum
				if(this.$refs.material.$refs.uploadList) {
					this.$refs.material.$refs.uploadList.clearSelectList([])
					this.$refs.material.$refs.uploadList.searchObj = {
						keywords: "",
        				page: 1
					}
				}
				if(typeNum === 3 && !this.row) {
					this.imgTextForm = {
						title: '',
						image_text: ''
					}
					this.$refs.imgText && this.$refs.imgText.resetFields()
				}
				this[type] = true
			},
			uploadSucess(list, item, row) {
				if(row) {
					let data = []
					if(row.isLocal) {
						data = this.uploadList
					} else {
						data = this.chapterList.list
					}
					let index= data.findIndex(obj => obj.fileName == item.newFileName)
					if(index !== -1) {
						item.status = data[index].status
						item.chapterId = data[index].id
						item.fileTtpeNum = data[index].fileTtpeNum
					}
				}
				this.copyTypeNum = this.type
				this.isUpLoadFinsh(row, [item])
			},
			async isUpLoadFinsh(row,list, variable0='image_text', variable1='url', variable2='name') {
				let ptypeObj = {
					1: 3,
					2: 2,
					3: 5
				}
				list.forEach( async (item) => {
					if(!item.requestFlag) {
						try {
							const params = {
								product_id: this.$route.params.id,
								// [!item.status ? 'title': '']: item[variable2],
								[variable1]: item[variable1],
								status: item.status || 4,
								type: item.fileTtpeNum?ptypeObj[item.fileTtpeNum]: ptypeObj[this.copyTypeNum],
								[variable0]: '',
								group_id:this.searchObj.group_id
							}
							if(!item.status) {
								params.title = item[variable2]
							}
							row ? params[item.status == 1? 'show_id': 'id'] = item.chapterId: ''
							item.requestFlag = true
							let res = await this[item.status == 1? 'showUpdate': 'createdshow'](params)
							this.promiseList.push(res)
							let index = this.uploadList.findIndex(obj => obj.isLocal? obj.id === res.id: obj.name == item.name)
							console.log(item, '=====')
							index !== -1 ? this.uploadList.splice(index, 1, { id: res.id, status: 4, url: item.url, image_text: item.image_text ,title:this.uploadList[index].title || item[variable2], sort: 1, duration: item.duration, is_transcode: 1, free: -1, ptype: item.fileTtpeNum?ptypeObj[item.fileTtpeNum]: ptypeObj[this.copyTypeNum], isLocal: true, fileType: item.vertically }): ''
							let indexs = this.chapterList.list.findIndex(obj => obj.id == res.id)
							indexs !== -1 ? this.chapterList.list.splice(indexs, 1, {...this.chapterList.list[indexs], url: item.url, image_text: item.image_text ,title: this.chapterList.list[indexs].title || item[variable2], duration: item.duration, ptype: item.fileTtpeNum ?ptypeObj[item.fileTtpeNum]: ptypeObj[this.copyTypeNum], process: '', fileType: item.vertically}): ''
						} catch (error) {
							item.requestFlag = true
							let index = this.uploadList.findIndex(obj => obj.id == item.id)
							index !== -1 ? this.$set(this.uploadList[index], 'type', 'error'): ''
						}
					}
				})
			},
			async sureMaterial(list) {
				// let list = [...fileslist] // 判断音视频时长
				// let uploadType = {
				// 	2: 'video',
				// 	3: 'audio'
				// }
				// if(this.staticPath === '/') {
				// 	let getUploadParams = getAliFileUploadUrl()
				// 	for (const item of fileslist) {
				// 		if(item.duration < getUploadParams[uploadType[item.fileType]].minTimes) {
				// 			await this.$message({
				// 				type: 'error',
				// 				duration: 3000,
				// 				message: item.name + '时长需大于1分钟'
				// 			})
				// 			let index = list.findIndex(ele => ele.id == item.id)
				// 			list.splice(index, 1)
				// 		}
				// 	}
				// }
				if(this.row) {
					let index = [...this.uploadList, ...this.chapterList.list].findIndex(obj => obj.id == this.row.id)
					list[0].status = [...this.uploadList, ...this.chapterList.list][index].status
					list[0].chapterId = [...this.uploadList, ...this.chapterList.list][index].id
					this.$nextTick(() => {
						this.$refs['upload_'+ this.row.id] && this.$refs['upload_'+ this.row.id][0].cancelUpload()
					})
				}
				this.contentFlag = false
				this.computedUploadList.push(...list)
				this.copyTypeNum = this.type
				this.isUpLoadFinsh(this.row, list)
			},
			async successFile(list,row) {
				if(row) {
					list.forEach(item => {
						let data = [...this.uploadList, ...this.chapterList.list]
						let index = data.findIndex(obj => obj.fileName == item.newFileName)
						if(index !== -1 && item.type !== 'error') {
							this.$set(data[index],'process', item.process)
						} else {
							this.$set(data[index],'process', '')
						}
					})
				} else {
					list.forEach(item => {
						let index = this.uploadList.findIndex(obj => obj.fileName == item.newFileName)
						if(index !== -1) {
							this.$set(this.uploadList, index, item)
						}
					})
				}
			},
			moveGroupMask(){
				this.moveGroup=true
			},
			moveGroupFn(){

			},
			addGroup() {//开启新建分组弹窗
				this.groupName = ''
				this.groupFlag = true
			},
			renGroup(item) {//开启重命名分组弹窗
				this.renGroupItem=item
				this.groupName = ''
				this.renGroupMask = true
				this.groupName=item.name
			},
			async addGroupSure(item={id:''}) {//新建分组 传id代表修改分组名称
				if(this.groupName_errorTitle) {
					return
				}
				let res = await this.addgroupFun({
					product_id:this.$route.params.id,
					id:item.id,
					group_name: this.groupName
				})
				
				let messageText=''
				if(item.id){
					this.renGroupMask = false//新建分组弹窗
					messageText='分组编辑成功'
					item.name=this.groupName
				}else{
					this.groupFlag = false//新建分组弹窗
					messageText='添加分组成功'
					this.groupList.push({
						id: res.id,
						name: res.name
					})
				}
				

				this.$message({
					type: 'success',
					message: messageText,
					duration: 3000
				})
			},
			getGroupName(value) {
				let obj = this.groupList.find(item => item.id == value)
				return obj ? obj.name: ''
			},
			clickGroup(row) {
				this.$set(row, 'groupFlag', true)
			},
			async editGroup(value, row) {//分组id 章节信息
				await this.createdshow({
					group_id: value,
					product_id: this.$route.params.id,
					id: row.id
				})
				await this.getShowlists()//章节数据
				this.moveGroup=false
				this.$message({
					message: '修改分组成功',
					type: 'success',
					duration: 3000
				})
			},
			changeStatus() {
				this.noDataName = 'noData'
				this.getShowlists(true)
			},
			changeGroup(id,index) {
				this.activeGroupingItem=id
				this.searchObj.group_id=id
				this.noDataName = 'noData'
				this.getShowlists(true)
			},
			changeSize(page) {//第几页
				this.searchObj.page = page
				this.getShowlists()
			},
			sizeChange(size){//每页多少条
				this.searchObj.page_size = size
				this.getShowlists()
			},
			async getShowlists (flag,sort_field,sort_order) {//sort_field,sort_order这两个字段用于排序
			this.isSection=false
			setTimeout(() => {
			this.isSection=true
				this.$nextTick(()=>{
					this.rowDropTwo()
				})
			}, 100);
				if(flag) {
					this.searchObj.page = 1
				}
				if(sort_field){
					this.searchObj.sort_field = sort_field
				}
				if(sort_order){
					this.searchObj.sort_order = sort_order
				}
				this.isCheckboxArr=[]
				this.loading=true
				let res = await this.showlist(this.searchObj)
				
				if (res.total_time) {
				  const totalSeconds = res.total_time;
				  const hours = Math.floor(totalSeconds / 3600);
				  const minutes = Math.floor((totalSeconds % 3600) / 60);
				  const seconds = totalSeconds % 60;
				  this.total_time = `${hours}时${minutes}分${seconds}秒`;
					// this.total_time = this.secondsToMinute(res.total_time)
				} else {
				  this.total_time = 0;
				}
				this.loading=false
				
				this.chapterList = {
					list: res.list?.map(item => {
						if(!item.group_id) {
							item.group_id = ''
						}
						item.fileType = item.ptype
						item['copy_sort'] = item.sort
						item['copy_title'] = item.title
						return item
					}),
					total: res.page_info.total_count,
					mix_time: res.mix_time
				}
				let inputList = this.headerList.filter(item => item.type == 'input')
				this.chapterList.list = this.chapterList.list.map(item => {
					for (const key in item) {
						let obj = inputList.find(ele => ele.prop === key)
						if (obj) {
							this.testkeyWordRule(item, obj.prop, obj.requiredTitle)
						}
					}
					return item
				})
				
			},
			async batchSureClick(requestType) {// 批量上架/下架请求 requestType 1批量上架 -2批量下架
			try{
				let res = await this.createdshow({ id:this.isCheckboxArr.join(','), product_id: this.$route.params.id, status: requestType})
				this.dialogVisible = false
				this.getShowlists()
			}catch(err){
				this.dialogVisible = false
				this.getShowlists()
			}
				
			},
			  secondsToMinute(value) {
				return dayjs.duration(value, 'seconds').format('HH时mm分ss秒') 
			  },
			async sureClick() {//上架请求
				let res = await this.createdshow({ id:this.row.id, product_id: this.$route.params.id, status: this.editParams.status})
				this.dialogVisible = false
				this.getShowlists()
			},
			editStatus(row) {
				console.log(row, '2323232')
				let content = ''
				let title = ''
				let sureBtn = ''
				let cancelBtn = ''
				let putList = [-2, 4, 2]
				let status = ''
				if(putList.includes(row.status * 1)) {
					let flag = true
					let inputList = this.headerList.filter(item => item.type == 'input').map(item => item.prop)
                    for (const key in row) {
						if(inputList.includes(key)) {
							if(row[key + '_errorTitle']) {
								flag = false
							}
						}
					}
					if(!flag) {
						return
					}
					content='上架课程需要进行审核，审核将自动上架，是否提交审核？'
					title='信息'
					sureBtn='是'
					cancelBtn = '否'
					status = 1
				} else {
					content='确定要下架该章节吗？'
					title='温馨提示'
					sureBtn='确认'
					cancelBtn = '取消'
					status = -2
				}
				this.editParams = {
					content,
					title,
					sureBtn,
					cancelBtn,
					status
				}
				this.row = row
				this.dialogVisible = true
			},
			edit(row) {
				// if(row.status == 1) {
				// 	return this.upEdit('章节')
				// }
				if(this.$route.params.type == 'column') { 
					this.handleBreadCrumb('/editChapter', '编辑章节', row.id, 4)
				} else {
					this.handleBreadCrumb('/editChapter', '编辑章节', row.id, 3)
				}

			},
			handleBreadCrumb(path, name, id, index = 2) {
				let breadCrumbList = this.breadCrumbList
				breadCrumbList[index] = {
					title: name,
					path: id ? `${path}/${this.$route.params.id}/${id}/${this.$route.params.type || 'columnList'}` : `${path}/${this.$route.params.id}/${this.$route.params.type}`
				}
				localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
				this.$router.push({
					path:id ? `${path}/${this.$route.params.id}/${id}/${this.$route.params.type || 'columnList'}` : `${path}/${this.$route.params.id}/${this.$route.params.type || 'columnList'}`
					// query: {
					// 	// breadCrumbList: JSON.stringify(breadCrumbList),
					// 	product_id: this.$route.params.id,
					// 	id
					// }
				})
			},
			downLoad(row) {
				// let a = document.createElement('a')
			},
			createClass(row) {
				if(row) {
					this.row = row
					this.multiple = false
					this.imgTextForm = {
						title: row.title,
						image_text: row.image_text
					}
				} else {
					this.multiple = true
					this.row = ''
				}
				this.contentFlag = true
			},
			search() {
				// this.searchObj.page = 1
				// this.getShowlists(this.searchObj)
				// this.$refs.pagination.firstPage()
				this.noDataName = 'noData'
				this.getShowlists(true)
			},
			test(params) {
				// console.log(params, '[[[]]]')
			},
			preview(row) {
				this.row = row
				this.previewFlag = true
				this.$nextTick(() => {
					this.initVideo()
				})
			},
			isFree(row) {
				let content = ''
				if(row.free == -1) {
					content = '是否设为试看'
				} else {
					content = '是否取消试看'
				}
				this.$confirm(content, '提示', {
					distinguishCancelAndClose: false,
					confirmButtonText: '是',
					cancelButtonText: '否',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(() => {
					let free = row.free == 1 ? -1 : 1
					this.$set(row, 'free', free)
					this.createdshow({ id:row.id, product_id: this.$route.params.id, free})
				})
			},
			recall(row) {
				this.$confirm('确定要撤回吗？', '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					let res = await this.showrecall({ id: row.id })
					if(res === 'success') {
						this.getShowlists()
						// this.$refs.pagination.firstPage()
					}
				})
			},
			deltes(row) {

				this.$confirm('确定要删除吗？', '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					await this.createdshow({ id:row.id, product_id: this.$route.params.id, status: -1 })
					this.$message(
						{
							type: 'success',
							message: '删除成功',
							duration: 3000
						}
					)
					let index = this.uploadList.findIndex(item => item.name == row.name)
					let promiseIndex = this.promiseList.findIndex(item => item.id == row.id)
					if(promiseIndex !== -1) {
						this.promiseList.splice(promiseIndex, 1)
					}
					if(index!==-1) {
						this.uploadList.splice(index, 1)
					} else {
						this.getShowlists()
					}
				})
			},
			searchGroup(query) {
				this.groupObj.name = query;
				this.groupObj.page = 1;
				this.groupList = [];
				this.noDataName = 'noData'
				setTimeout(() => {
					this.searchGroupData();
				}, 100);
			},
			async searchGroupData() {//请求分组列表数据
				let res = await this.getGroupList({ is_all: 1, product_id: this.$route.params.id})
				this.groupList = res.data

				
			},
			setLoadMore() {
				this.$nextTick(() => {
					let that = this;
					//获得元素
					const loadSelectElement = document.querySelector('.loadMoreSelect .el-scrollbar__wrap')
					function scrollLoadData() {
						//如果已加载完全部数据直接返回
						if (that.getGroupAll) {
							return '';
						}
						// 当滚动条高度等于卷入高度+可视高度时，说明到达底部，scrollHeight :滚动条高度，scrollTop ：已卷入不可见的滚动条高度，clientHeight：可见的滚动条高度。
						const scrollDistance = loadSelectElement.scrollHeight - loadSelectElement.scrollTop - loadSelectElement.clientHeight;
						if (scrollDistance <= 0) {
							that.groupObj.page += 1;
							that.searchGroupData();
						}
					}
					loadSelectElement.addEventListener('scroll', scrollLoadData,);
				})
			},
			async getSensitiveFun() {
				let res = await this.getSensitive()
				this.keyWordList = res
			},
			groupInpChange() {
				this.testkeyWordRule(this, 'groupName', '分组名称')
			},
			previewMediaClose(done) {
				this.previewFlag = false
				try{
					const video = this.$refs.previewVideo
					if(video) {
						video.pause();//暂停
					}
				}catch(e){
					//TODO handle the exception
				}
				done();
			},
			reshList() {
				this.$refs.material.$refs.uploadFile ?  this.$refs.material.$refs.uploadFile.uploadList = []: ''
				this.uploadList = []
				this.promiseList = []
				this.computedUploadList = []
				if(this.row) {
					this.getShowlists()
				} else {
					this.getShowlists(true)
				}
			},
			initVideo(){
				const player = videojs(this.$refs.previewVideo,{
					bigPlayButton: true, 
					posterImage: false,
					errorDisplay: false,
					//设置小喇叭音量键
					controlBar: {
						fullscreenToggle: true,
						// 音量条的横向还是纵向显示
						volumePanel: {
						inline: false,
						},
					},
					muted: false // //静音模式   解决首次页面加载播放。
				})
				console.log(player, '===player')
			},
			watchAgreement() {
				window.open(`/agreeContent`)
			},
			async changeFileType(row, value) {
				await this.createdshow({
					product_id: this.$route.params.id,
					id: row.id,
					type: value
				})
			}
		},
		filters: {
			filterType(value){
				let obj = {
					2: '音频',
					3:'视频',
					4:'视频',
					5:'图文'
				}
				return obj[value]
			}
		},
		watch: {
			searchObj: {
				deep: true,
				handler(news) {
					// this.getClassLists(news)
				}
			},
			isCheckboxArr:{
				deep: true,
				handler(news) {
					if(this.isCheckboxArr.length==this.chapterList.list.length&&this.chapterList.list.length>0){
					this.checkAll=true
				}else{
					this.checkAll=false

				}
				}
			},

			isReshList: {
				deep: true,
				handler(news) {
					if(news[0].length && news[0].length == news[1].length) {
						this.reshList()
					}
				}
			},
			groupList:{
				handler(news) {
				this.searchObj.group_id=this.activeGroupingItem
				this.isGrouping=false
				setTimeout(() => {
				this.isGrouping=true
					this.$nextTick(()=>{
						this.rowDropOne()
					})
				}, 100);
				//保存一份克隆后的数据
				this.copy_sort1=JSON.parse(JSON.stringify(this.groupList))

				// this.getShowlists()//章节数据
				}
			},
			'chapterList.list':{
				handler(news) {
				
				//保存一份克隆后的数据
				this.copy_sort2=JSON.parse(JSON.stringify(this.chapterList.list))
				}
			}
		}
	}
</script>
<style lang="less">
.video-screen {
	margin-top: 6px;
	.el-radio-group {
		.el-radio {
			margin-right: 10px;
			.el-radio__label {
				padding-left: 6px;
			}
		}
	}
}
#group_id{
	.el-table__empty-block{
		display: none!important;
		text-align: center;
		
		
	}
	
}
.read {
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 12px;
	>span {
		color: #1989FA;
		
		cursor: pointer;
	}
}
.el-tooltip__popper {
   transform: translateX(8px);
  }
  .grouping-class{
	display: flex;
	align-items: center;
	justify-content: space-between;
	&:hover{
	.drag-handles-grouping{
		opacity: 1!important;
	}
	} 
	
  }
  .el-table__row{
		&:hover{
			.drag-handles-chapter{
				opacity: 1!important;
			}
		}
	}

	.drag-handles-chapter{
		width: 40px;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		box-sizing: border-box;
		white-space: nowrap;
	
		padding: 0px 8px;
		font-size: 10px;

		color: #FFFFFF;
		background: rgba(0, 0, 0, 0.6);
		opacity: 0;
	}
.chaochu{
		width: 120px;
		overflow: hidden;
		text-overflow: ellipsis; 
		-o-text-overflow: ellipsis;
		white-space:nowrap;
	}
	.drag-handles-grouping{
		height: 47px;
		line-height: 47px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		padding: 0 8px;
		font-size: 10px;

		color: #FFFFFF;
		background: rgba(0, 0, 0, 0.6);
		opacity: 0;
	}
	
	.ji-xiu{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding-left: 150px;
	}
.moni-input{
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    width: 100%;

	overflow: hidden;
    text-overflow: ellipsis; 
    -o-text-overflow: ellipsis;
    white-space:nowrap;
	text-align: left;
	position: relative;
	i{
		position:absolute;
		right:4px;
		top:50%;
		transform: translateY(-50%);	
	}
}
.dis-none{
	display: none!important;
	opacity: 0;
}
.active-hr{
		background-color: #409eff!important;
		color: #FFFFFF!important;
		&:hover {
				td{
				background-color: #409eff!important;
		color: #FFFFFF!important;
		}
		}
	
	}
			
.sort-div{
		display: flex;
		justify-content: space-around;
		align-items: center;
			.active-ascending{
			border-bottom-color: #409eff!important;

			}
			.active-descending{
			border-top-color: #409eff!important;
			
			}
	}
	@classNames: chapter;
	.common_button {
		width: 77px;
		height: 28px;
		padding: 0;
		text-align: center;
		line-height: 28px;
	}
	.@{classNames}_input_error {
		.el-input__inner {
			border-color: #f56c6c;
		}
	}
	.@{classNames}_error_title {
		color: rgb(245, 108, 108);
		font-size: 12px;
		line-height: 14px;
		position: absolute;
		left: 8px;
		margin-top: 46px;
		display: inline-block;
	}
	.@{classNames}_preview_dialog {
		.img_text {
			img {
				max-width: 100%;
			}
		}
	}
	.@{classNames}_dialog_type {
		.btn_list {
			display: flex;
			justify-content: center;
			align-items: center;
			min-height: 150px;
			.el-button {
				display: inline-block;
				padding: 12px 48px;
			}
		}
	}
	.loadMoreSelect {
		.el-select-dropdown__item {
			padding: 0 12px;
		}
	}
	.@{classNames}_group {
		
		display: flex;
		align-items: center;
		
		>p {
			flex: 1;
		}
		.group_operation {
			i {
				color:#409eff;
				font-weight: 500;
				font-size: 18px;
				&:nth-child(1) {
					margin-left: 4px;
				}
			}
			.icon_disabled {
				color: #ccc;
				cursor: not-allowed;
			}
		}
	}
	.@{classNames} {
		// .v-modal {
		// 	z-index: 1900!important;
		// }
		// .el-dialog__wrapper {
		// 	z-index: 1901!important;
		// }
		.el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search_btn {
			width: 70px;
			height: 40px;
			background: #1989FA;
			border-radius: 0px 2px 2px 0px;
			color: #FFFFFF;
			font-size: 14px;
		}
		.@{classNames}_operation_title {
			// margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
			// &:not(:last-child) {
			// 	margin-right: 12px;
			// }

		}
		.@{classNames}_table_imgtitle {
			.@{classNames}_table_imgtitle_con {
				height: 119px;
				display: flex;
				overflow: hidden;
				&.@{classNames}_table_imgtitle_edit {
					&:hover {
						.repace_class {
							transform: translateY(0);
							transition: all 0.2s linear;
						}
					}
				}
				
			}
			.@{classNames}_table_imgtitle_left {
				position: relative;
				margin-right: 10px;
				width: 90px;
				height: 119px;
				flex-shrink: 0;
				img {
					width: 100%;
					height: 100%;
				}
				.duration {
					position: absolute;
					bottom: 0;
					right: 0;
					height: 20px;
					width: 44px;
					background:rgba(0, 0, 0, 0.3);
					text-align: center;
					line-height:20px;
					font-size: 12px;
					font-weight: 400;
					color: #FFFFFF;
				}
				.repace_class {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background:rgba(0, 0, 0, 0.3);
					z-index: 10;
					display: flex;
					align-items: center;
					justify-content: center;
					transform: translateY(100%);
				}
			}
			.@{classNames}_table_imgtitle_right {
				display: flex;
				flex-direction: column;
				justify-content: center;
				.@{classNames}_table_right_top {
					.@{classNames}_table_right_title {
						width: 155px;
						font-size: 14px;
						color: #606266;
						line-height: 20px;
						overflow: hidden;
						display: -webkit-box;
						white-space: pre-wrap;
						word-wrap: break-word;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
					.@{classNames}_table_right_price {
						margin-top: 14px;
						font-size: 16px;
						font-weight: 500;
						color: #EC4561;
						line-height: 20px;
					}
				}
				.@{classNames}_table_right_bot {
					.@{classNames}_table_bot_status {
						display: flex;
						flex-direction: column;
						// align-items: center;
						.@{classNames}_table_bot_status_tit {
							width: 66px;
							height: 24px;
							border-radius: 12px;
							margin-right: 10px;
							text-align: center;
							line-height: 24px;
						}
						.@{classNames}_table_bot_reason {
							font-size: 14px;
							color: #65B2FF;
							line-height: 20px;
							margin-top: 10px;
						}
					}
					.@{classNames}_table_bot_time {
						font-size: 12px;
						color: #606266;
						line-height: 12px;
						margin-top: 12px;
					}
				}
			}
		}
		.@{classNames}_process {
			.@{classNames}_process_con {
				display: flex;
				justify-content: space-between;
				margin-bottom: 8px;
			}
		}
		.@{classNames}_search_con_item {
			.el-input-group__append {
				background: #1989FA;
				color: #fff;
			}
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_group_dialog {
		.el-dialog__body {
			padding: 12px;
		}
		.el-dialog__footer {
			.el-button {
				&:extend(.common_button);
			}
		}
	}
	.@{classNames}_common_dialog {
		padding: 30px;
		width: 360px;
		box-sizing: border-box;
		.el-message-box__header {
			padding: 0;
		}
		.el-message-box__headerbtn {
			top: 0;
			right: 0;
		}
		.el-message-box__content {
			padding: 0;
			.el-message-box__message {
				padding-top: 12px;
				padding-bottom: 16px;
			}
		}
		.el-message-box__btns {
			.el-button {
				&:extend(.common_button);
			}
		}
	}
</style>
<style lang='less' scoped>
	@classNames: chapter;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;

		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 12px;
			flex-shrink: 0;
			.@{classNames}_search_con {
				display: flex;
			}
		}
		.@{classNames}_search_con_item {
			display: flex;
			align-items: center;
			margin-right: 16px;

			.@{classNames}_search_con_item_title {
				white-space: nowrap;
				font-size: 14px;
				color: #606266;
				margin-right: 12px;
			}
		}
		.@{classNames}_con {	
			display: flex;
			flex-direction: column;
			flex: 1;
			/*.@{classNames}_con_table {
				width: 100%;
			} */
		}
	}
	.@{classNames}_batch {
		height: 40px;
		width: 100%;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding-left: 200px;
	}
	.@{classNames}_con_content {
		display: flex;
		flex: 1;
		
		.@{classNames}_con_grouping {
	  width:200px;
      height: 100%;
      box-sizing: border-box;
      border: 1px solid #d7d7d7;
	  margin-right: 10px;
      .compile-icon{
        float: right;
        margin-right: 10px;
		margin-top: 18px;
      }
	  
      .tab-item{
        width: 100%;
        height: 48px;
        border-bottom: 1px solid #EBEEF5;
        padding: 12px 0 12px 10px;
        box-sizing: border-box;
        text-align: left;
        font-size: 14px;
        color: #606266;
      }
	  .tab-item:hover{
       background: #f5f7fa;
      }
		}
	}
	
</style>
